import * as actionType from "./action";

const initialState = {
  categories: [],
  expandedCards: {},
  currentCategory: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_ALL_CATEGORY: {
      const rawCategories = action.payload;
      const normalizedCategories = Array.isArray(rawCategories)
        ? rawCategories.map((cat) => ({
            ...cat,
            Id: cat.id,
            FatherId: cat.parentId,
            Name: cat.name,
          }))
        : [];

      return {
        ...state,
        categories: normalizedCategories,
      };
    }
    // case actionType.ADD_CATEGORY: {
    //     const categories = [...state.categories];
    //     categories.push(action.payload);
    //     categories.sort((a, b) => a.OrderNumber - b.OrderNumber);
    //     return {
    //         ...state,
    //         categories: categories
    //     };
    // }

    case actionType.ADD_CATEGORY: {
      const newCat = {
        ...action.payload,
        Id: action.payload.id,
        FatherId: action.payload.parentId,
        Name: action.payload.name,
      };
      const categories = [...state.categories, newCat];
      categories.push(action.payload);
      categories.sort((a, b) => a.OrderNumber - b.OrderNumber);
      return {
        ...state,
        categories: categories,
      };
    }
    case actionType.EDIT_CATEGORY: {
      const newCategories = state.categories.map((category) => {
        if (category.id === action.payload.id) {
          return {
            ...category,
            [action.payload.paramName]: action.payload.value,
          };
        }
        return category;
      });

      if (action.payload.paramName === "OrderNumber") {
      }

      return {
        ...state,
        categories: newCategories,
      };
    }

    case actionType.DELETE_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category.slug !== action.payload,
        ),
      };

    case actionType.TOGGLE_EXPAND_CARD:
      return {
        ...state,
        expandedCards: {
          ...state.expandedCards,
          [action.payload]: !state.expandedCards[action.payload],
        },
      };

    case actionType.RESET_EXPANDED_CARDS:
      return {
        ...state,
        expandedCards: {},
      };
    case actionType.UPDATE_CATEGORY_BRANCH: {
      const { items, parentId } = action.payload;

      // 1. נרמול הנתונים - וודא שכל השדות שה-UI מצפה להם קיימים
      const normalizedNewItems = items.map((cat) => ({
        ...cat,
        Id: cat.id, // התאמה ל-SET_ALL_CATEGORY
        FatherId: cat.parentId, // התאמה ל-SET_ALL_CATEGORY
        Name: cat.name, // התאמה ל-SET_ALL_CATEGORY
        // שומרים גם את המקוריים ליתר ביטחון
      }));

      // 2. סינון אחים ישנים
      const otherCategories = state.categories.filter(
        (cat) =>
          String(cat.parentId || cat.FatherId || "") !== String(parentId),
      );

      // 3. איחוד ומיון
      const finalCategories = [...otherCategories, ...normalizedNewItems].sort(
        (a, b) => {
          // אם יש rank (מחרוזת מהשרת), נשתמש במיון מחרוזות
          if (a.rank && b.rank) {
            return a.rank.localeCompare(b.rank);
          }
          // ברירת מחדל למיון מספרים
          return (a.OrderNumber || 0) - (b.OrderNumber || 0);
        },
      );

      console.log(
        "✅ Final categories count in state:",
        finalCategories.length,
      );

      return {
        ...state,
        categories: finalCategories,
      };
    }

    case actionType.SET_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
